<script setup lang="ts">
    import { ModelType } from '@/app/base/schemas/BaseSchema';
    import EndpointFactory from '@/app/factories/EndpointFactory';
    import InvoiceTemplateSectionColumnEndpoint from '@/app/invoicing/endpoints/InvoiceTemplateSectionColumnEndpoint';
    import InvoiceTemplateSectionColumn from '@/app/invoicing/models/InvoiceTemplateSectionColumn';

    const { contextMenu, onAction, onPromise } = useModelContextMenu();
    const deleteButton = ref(null);

    const destroy = async (model: InvoiceTemplateSectionColumn) => {
        await deleteButton.value!.loadUntil(onPromise(useDeleteModel<InvoiceTemplateSectionColumn>(model)));
    };
</script>

<template>
    <ModelContextMenu
        :model-type="InvoiceTemplateSectionColumn"
        :menu-height="100"
        v-slot="slotProps"
        ref="contextMenu"
    >
        <LoadingButton
            :class-name="$theme('contextmenu.link')"
            @click.prevent="onAction(() => slotProps.model.edit())"
        >
            <i
                class="fa-pencil"
                :class="$theme('contextmenu.icon')"
            ></i>
            <span>{{ $t('actions.edit') }}</span>
        </LoadingButton>
        <LoadingButton
            :class-name="$theme('contextmenu.link')"
            @click.prevent="destroy(slotProps.model)"
            ref="deleteButton"
        >
            <i
                class="fa-trash"
                :class="$theme('contextmenu.icon')"
            ></i>
            <span>{{ $t('actions.delete') }}</span>
        </LoadingButton>
    </ModelContextMenu>
</template>
